/* istanbul ignore file */
export * from './Layout3';
